customElements.get("recently-viewed") || customElements.define("recently-viewed", class extends HTMLElement {
  container=this.querySelector("[data-slider]");
  sliderComponent=this.querySelector("slider-component");
  constructor() {
    super(), Shopify = Shopify || {}, Shopify.recentlyViewed = JSON.parse(localStorage.getItem("recentlyViewed")) || [];
  }
  show() {
    this.closest(".shopify-section").setAttribute("data-recent-loaded", !0), this.closest('.shopify-section:not([id*="drawer"])')?.classList.add("my-3xl", "tablet:my-xl");
  }
  async loadProduct(e) {
    const t = location.href.match("/products/([^?]+)");
    if (!t || e !== t[1]) try {
      const t = await fetch(`${Shopify.routes.root || "/"}products/${e}?view=card`);
      if (!t.ok) throw 404 === t.status && (Shopify.recentlyViewed = Shopify.recentlyViewed.filter(t => t !== e), 
      localStorage.setItem("recentlyViewed", JSON.stringify(Shopify.recentlyViewed))), 
      Error(t.statusText);
      const i = await t.text(), o = (new DOMParser).parseFromString(i, "text/html"), s = document.createElement("li");
      s.classList.add("w-grid", "shrink-0", "relative", "snap-start", "tablet:snap-center"), 
      s.setAttribute("data-slide", ""), s.innerHTML = o.body.innerHTML, this.container.appendChild(s), 
      this.classList.remove("hidden");
    } catch (t) {
      console.warn("Could not load product: " + e + ". " + t);
    }
  }
  async loadProducts() {
    try {
      await Promise.all(Shopify.recentlyViewed.map(e => this.loadProduct(e.split("#")[0]))), 
      this.show(), this.sliderComponent.outerHTML = this.sliderComponent.outerHTML, this.emitState();
    } catch (e) {
      console.error("Error loading products:", e);
    }
  }
  connectedCallback() {
    this.container && Shopify.recentlyViewed && (Shopify?.recentlyViewed?.length > 0 ? this.loadProducts() : this.emitState());
  }
  emitState() {
    const e = !!this.container?.querySelector("[data-slide]");
    this.dispatchEvent(new CustomEvent("recently-viewed:state", {
      detail: {
        hasContent: e
      },
      bubbles: !0
    }));
  }
});